import _ from "lodash";
import { extractContentFromHTML } from "Utils";
import {
  getOrganizationResourceFromCache,
  getQuestionFromCacheV2,
} from "Worksheet/modules/WorksheetGraphqlHelpers";
import { getOrganizationResourceFromCacheV2 } from "QuestionBank/modules/QuestionBankGraphqlHelper";
import {
  FIELD_UID_TITLE,
  QUESTION_UID_FIND_HOTSPOT,
  QUESTION_UID_DRAG_AND_DROP,
  QUESTION_UID_LABELLING,
  MODE_STUDENT_EVALUATE,
} from "Worksheet/modules/WorksheetConstants";

const QUESTION_TYPE_LOCALES = {
  [QUESTION_UID_FIND_HOTSPOT]: {
    questionPreviewSidebarTitle: "worksheet:hotspot",
    addElementButtonLabel: "worksheet:hotspot",
  },
  [QUESTION_UID_DRAG_AND_DROP]: {
    questionPreviewSidebarTitle: "worksheet:drag_and_drop",
    addElementButtonLabel: "worksheet:drop_zones",
  },
  [QUESTION_UID_LABELLING]: {
    questionPreviewSidebarTitle: "worksheet:labelling",
    addElementButtonLabel: "worksheet:label",
  },
};

/**
 *
 * @param {*} title
 * @returns Checking if question title is empty or not
 */
const isQuestionTitleEmpty = title => {
  const titleFieldData = extractContentFromHTML({ htmlString: title });
  return _.isEmpty(titleFieldData) || /^\s*$/.test(titleFieldData);
};

/**
 *
 * @param {*} t
 * @param {*} config
 * @returns Question detail to show on preview sidebar
 */
export const getQuestionPreviewDetail = (
  t,
  config,
  userType,
  worksheetMode,
  isFromInternalTool
) => {
  const isSubQuestion = _.get(config, "isSubQuestion", false);
  const resourceId = _.get(config, "resourceId", null);
  const subQuestionParentId = _.get(config, "subQuestionParentId", null);
  const cacheId = isSubQuestion ? subQuestionParentId : resourceId;
  const showAssessmentTools = _.isEqual(worksheetMode, MODE_STUDENT_EVALUATE);

  const questionCacheData = isFromInternalTool
    ? getOrganizationResourceFromCacheV2(cacheId)
    : getOrganizationResourceFromCache(
        cacheId,
        true,
        userType,
        showAssessmentTools
      );

  let dataFields = _.get(questionCacheData, "item.fields");
  let questionTypeUid = _.get(questionCacheData, "item.questionType.uid", "");

  if (isSubQuestion) {
    const subQuestionDetail = _.find(
      _.get(questionCacheData, "childrenV2.edges"),
      item => _.get(item, "node.item.id") === _.get(config, "questionId", "")
    );
    // * if it is multipart question, get detail from nested object
    dataFields = _.get(subQuestionDetail, "node.item.fields");
    questionTypeUid = _.get(subQuestionDetail, "node.item.questionType.uid");
  }

  // * Getting question title
  let questionTitle = _.get(
    _.find(dataFields, { uid: FIELD_UID_TITLE }),
    "value",
    ""
  );
  if (isQuestionTitleEmpty(questionTitle)) {
    questionTitle = t("worksheet:untitled_question");
  }

  const questionLocales = _.get(
    QUESTION_TYPE_LOCALES,
    questionTypeUid,
    "drag_and_drop"
  );

  return {
    questionTitle,
    questionLocales,
    questionTypeUid,
    isDragAndDrop: questionTypeUid === QUESTION_UID_DRAG_AND_DROP,
  };
};

/**
 *
 * @param {*} t
 * @param {*} config
 * @returns Question detail to show on preview sidebar
 */
export const getQuestionPreviewDetailV2 = ({
  t,
  config,
  userType,
  isFromInternalTool,
}) => {
  let questionTypeUid, dataFields;
  if (isFromInternalTool) {
    // WORKSHEET_RESTRUCTURING: Replace this logic with new queries once support is added in internal tool
    const resourceId = _.get(config, "resourceId", null);
    const subQuestionParentId = _.get(config, "subQuestionParentId", null);
    const isSubQuestion = _.get(config, "isSubQuestion", false);
    const cacheId = isSubQuestion ? subQuestionParentId : resourceId;
    const questionCacheData = getOrganizationResourceFromCacheV2(cacheId);

    dataFields = _.get(questionCacheData, "item.fields");
    questionTypeUid = _.get(questionCacheData, "item.questionType.uid", "");

    if (isSubQuestion) {
      const subQuestionDetail = _.find(
        _.get(questionCacheData, "childrenV2.edges"),
        item => _.get(item, "node.item.id") === _.get(config, "questionId", "")
      );
      // * if it is multipart question, get detail from nested object
      dataFields = _.get(subQuestionDetail, "node.item.fields");
      questionTypeUid = _.get(subQuestionDetail, "node.item.questionType.uid");
    }
  } else {
    // Fetch question from cache v2
    const questionId = _.get(config, "questionId", null);

    const questionCacheData = getQuestionFromCacheV2({
      id: questionId,
      userType,
    });

    dataFields = _.get(questionCacheData, "fields");
    questionTypeUid = _.get(questionCacheData, "questionType.uid", "");
  }
  // * Getting question title
  let questionTitle = _.get(
    _.find(dataFields, { uid: FIELD_UID_TITLE }),
    "value",
    ""
  );
  if (isQuestionTitleEmpty(questionTitle)) {
    questionTitle = t("worksheet:untitled_question");
  }
  const questionLocales = _.get(
    QUESTION_TYPE_LOCALES,
    questionTypeUid,
    "drag_and_drop"
  );
  return {
    questionTitle,
    questionLocales,
    questionTypeUid,
    isDragAndDrop: questionTypeUid === QUESTION_UID_DRAG_AND_DROP,
  };
};
